export const SHOES_REQUEST_PENDING = "SHOES_REQUEST_PENDING"
export const SHOES_DATA_FAILURE = "SHOES_DATA_FAILURE"


//Get Shoes Data
export const GET_SHOES_REQUEST_SUCCESSFUL = "GET_SHOES_REQUEST_SUCCESSFUL"

//Get Shoes Data for Admin
export const GET_SHOES_REQUEST_ADMIN_SUCCESSFUL = "GET_SHOES_REQUEST_ADMIN_SUCCESSFUL"

//Post Shoes Data
export const POST_SHOES_REQUEST_SUCCESSFUL = "POST_SHOES_REQUEST_SUCCESSFUL"

//Delete Shoe Data
export const DELETE_SHOE_REQUEST_SUCCESSFUL = "DELETE_SHOE_REQUEST_SUCCESSFUL"

//Edit Shoe Data
export const EDIT_SHOE_REQUEST_SUCCESSFUL = "EDIT_SHOE_REQUEST_SUCCESSFUL"
